import React from 'react';
import './DashboardStatCard.css';

/**
 * Reusable dashboard stat card component.
 *
 * @param {React.ReactNode}  icon       - Ant Design icon element
 * @param {string|number}    value      - Stat value (auto-formatted with toLocaleString if number)
 * @param {string}           label      - Label text below the value
 * @param {string}           iconBg     - Background color for the icon container (e.g. '#fff3eb')
 * @param {string}           iconColor  - Icon color (e.g. '#ff6700')
 * @param {React.ReactNode}  [trend]    - Optional trend badge element (e.g. "↑ Live", "↓ Alert")
 * @param {React.ReactNode}  [extra]    - Optional extra content rendered after the label
 * @param {string}           [className] - Optional extra class names
 */
const DashboardStatCard = ({
  icon,
  value,
  label,
  iconBg = '#fff3eb',
  iconColor = '#ff6700',
  trend,
  extra,
  className = '',
}) => {
  const formattedValue =
    typeof value === 'number' ? value.toLocaleString() : value;

  return (
    <div className={`ds-stat-card ${className}`}>
      <div className="ds-stat-header">
        <div
          className="ds-stat-icon"
          style={{ background: iconBg, color: iconColor }}
        >
          {icon}
        </div>
      </div>
      <span className="ds-stat-value">{formattedValue}</span>
      <span className="ds-stat-label">
        {label}
        {extra && <>{extra}</>}
      </span>
    </div>
  );
};

export default DashboardStatCard;
